<template>
  <v-card flat>
    <v-card-title class="grey lighten-4" v-if="!hide_title">
      <h3 class="secondary--text">{{ $t(`rms.media.collection.${media_type}`) }}</h3>
      <v-spacer></v-spacer>
    </v-card-title>
    <v-card-text>
      <v-layout row wrap v-if="medias">
        <!-- Add more button -->
        <v-flex xs4 md2 lg2 pa-2>
          <v-card height="100px" color="grey lighten-3" class="text" @click="linkMore">
            <v-container bg fill-height grid-list-md>
              <v-layout row wrap align-center text-xs-center>
                <v-flex >
                  <!-- <v-tooltip slot="append" top color="white" v-if="medias.length != 1">
                    <v-btn outline icon color="secondary" slot="activator">
                      <v-icon>add</v-icon>
                    </v-btn>
                    <span class="greyDarken3--text body-1">
                      Add
                      {{ $t(`rms.media.collection.${media_type}`) }}
                    </span>
                  </v-tooltip> -->
                  <v-tooltip slot="append" top color="white">
                    <v-btn outline small flat color="secondary" slot="activator">
                      {{$t('rms.media.collection.thumbs.add.edit.btn')}}
                    </v-btn>
                    <span class="greyDarken3--text body-1">
                      Edit
                      {{ $t(`rms.media.collection.${media_type}`) }}
                    </span>
                  </v-tooltip>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card>
        </v-flex>
        <!-- Media preview -->
        <v-flex xs4 md2 lg2 v-for="item in medias" v-bind:key="item.file_id" pa-2>
          <v-hover>
            <v-card
              v-if="
                (item.file_mimetype.includes('image') ||
                  item.file_mimetype.includes('video')) &&
                  media_type!=DEFINES.MEDIA.FILM.SCREENERS
              "
              @click="showMediaPreview(item)"
              height="100px"
              hover
              class="text"
              slot-scope="{hover}"
            >
              <v-layout row wrap>
                <v-flex xs12 class="white--text grey lighten-3">
                  <v-layout row>
                    <v-flex xs12>
                      <v-tooltip slot="append" top color="white">
                        <v-img slot="activator" :src="item.thumb" height="100px" contain>
                          <v-expand-transition :key="item.file_id">
                            <div
                              v-if="hover"
                              class="d-flex transition-fast-in-fast-out error v-card--reveal white--text text-xs-center"
                              style="height: 30%;"
                              @click.stop="removeMedia(item.file_id)"
                            >
                              <span class="body-2">Deselect</span>
                            </div>
                          </v-expand-transition>
                        </v-img>
                        <span class="greyDarken3--text body-1">
                          {{
                          $t(`rms.media.collection.${media_type}`)
                          }}&nbsp;Preview
                        </span>
                      </v-tooltip>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-card>
          </v-hover>
          <ConfirmationDialog
            v-if="dialog"
            :dialog="dialog"
            @confirm="removeMedia(item.file_id)"
            @cancel="dialog = false"
          ></ConfirmationDialog>
        </v-flex>

        <v-container class="pa-0">
          <v-dialog max-width="27%" :value="showPreview" persistent>
            <v-card>
              <v-card-title>
                <div class="title">{{ $t(`rms.media.collection.${media_type}`) }}&nbsp;Preview</div>
                <v-spacer></v-spacer>
                <v-btn
                  small
                  dark
                  icon
                  color="grey"
                  @click="(showPreview = false), (videoUrl = null)"
                  class="mx-0"
                >
                  <v-icon small>$vuetify.icons.rms_close</v-icon>
                </v-btn>
              </v-card-title>
              <v-card-text>
                <embed-player
                  v-if="videoUrl"
                  v-bind:value="videoUrl"
                  :video_type="medias[0].file_mimetype"
                ></embed-player>
                <div v-else>
                  <img :src="thumb" width="100%" height="100%" />
                </div>
              </v-card-text>
            </v-card>
          </v-dialog>
        </v-container>
      </v-layout>
    </v-card-text>
  </v-card>
</template>
<script>
import EmbedPlayer from "@/components/media/EmbedPlayer.vue";
import ConfirmationDialog from "@/components/dialogBox/Confirmation";

export default {
  props: ["media_type", "mime_type", "max_selections", "collection", "hide_title", "is_screener_upload"],
  name: "MediaContainer",
  components: {
    EmbedPlayer,
    ConfirmationDialog
  },
  data() {
    return {
      showPreview: false,
      videoUrl: null,
      video_type: null,
      thumb: null,
      dialog: false
    };
  },
  computed: {
    medias: function() {
      return this.$store.getters["film/getMediasFromId"](this.media_type);
    }
  },

  methods: {
    linkMore() {
      this.$emit("link", {
        media_type: this.media_type,
        mime_type: this.mime_type,
        max_selections: this.max_selections,
        collection: this.collection
      });
    },
    async showMediaPreview(media) {
      if(this.is_screener_upload){
        return this.$emit('watchPreview');
      }
      var result = await this.$store.dispatch("files/getPreviewUrl", {
        id: media.file_id
      });

      this.showPreview = true;
      if (media.file_mimetype.includes("video")) {
        this.videoUrl = result.url;
        // this.videoUrl = media.video_url;
        this.video_type = media.mime_type;
      } else {
        this.thumb = media.thumb;
      }
    },
    removeMedia(media_id) {
      this.$emit("removeMedia", {
        media_type: this.media_type,
        media_id: media_id
      });
      this.dialog = false;
    }
  }
};
</script>
<style scoped>
.custom_border_2px {
  border: 2px solid lightgray;
  border-radius: 20px;
}
.display_contents {
  display: contents;
}

.v-card--reveal {
  align-items: center;
  bottom: 0;
  justify-content: center;
  opacity: 1;
  position: absolute;
  width: 100%;
}
</style>
